import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { PageHeader } from '../../components';
import FarmDashboard from './components/farmDashboard';
// import FarmDashboardforTable from './components/farmDashboardforTable';
//import ShedDetailsinTable from './shedDetailsinTable';
// import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles(theme => ({
    root: {},
    content: props=>({
        margin: props.isDesktop?theme.spacing(4):theme.spacing(1)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    progressBar: {
        margin: theme.spacing(2)
    },
}));

const Dashboard = ({showError,match, history}) => {


    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({isDesktop});
    const farmID = match.params['farmID'];
    // const [tableView,setTableView] = useState(false);
    // const viewChange = (event,togglestate)=> {
    //     console.debug(event,togglestate)
    //     setTableView(togglestate)
    // }

    return (
        <div className={classes.root}>
            <PageHeader
                title={`Farm Overview - ${window.localStorage.getItem("farmName")}`}
                breadcrumbs={[
                    { label: 'Home', onClick: () => history.push('/') },
                    { label: 'Farm' },
                ]}
            />
            {/* {tableView ?
            <Grid container
            spacing={3} >
                <FarmDashboardforTable showError={showError} farmID={farmID}/>
            </Grid>

                : ""
            } */}
            <div className={classes.content}>
            <Grid
                container
                spacing={3}
            >
                <FarmDashboard showError={showError} farmID={farmID}/>
            </Grid>
            </div>
        </div>
    );
};

export default Dashboard;
